var render = function render(_c,_vm){return _c('section',{staticClass:"progress-wrapper"},[_c('div',{staticClass:"progress-bar",attrs:{"role":"progressbar","aria-valuenow":_vm.props.value,"aria-valuemin":"0","aria-valuemax":"100"}},[_c('div',{class:[
                'progress-value',
                { 'completed': _vm.props.value >= 100 }
            ],style:({ 'width': _vm.props.value + '%' })})]),_c('p',{staticClass:"progress-percent"},[_vm._v(_vm._s(_vm.props.value)+"%")])])
}
var staticRenderFns = []

export { render, staticRenderFns }